// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__lOFJA","showOnMobileOnly":"Hero_showOnMobileOnly__wdg1i","wrapper":"Hero_wrapper__7SWmn","leftColumn":"Hero_leftColumn__ASOJN"};